import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ignoreNil } from "@obg/ngx.global";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { KycConfig } from "../kcy.config";

import { DepositThresholdService } from "./deposit-thershold.service";
import { DepositThresholdAction } from "./deposit-threshold.action";

/**
 * @deprecated - [fabric-deprecated] - Use event bus retrieve with AccountAppValue instead
 */
@Injectable()
export class DepositThresholdEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use event bus retrieve with AccountAppValue.FetchThresholdStatus instead
	 */
	fetchThreshold$ = createEffect(() =>
		this.actions$.pipe(
			ofType(DepositThresholdAction.fetch),
			withLatestFrom(this.kycConfig.isDepositThresholdEnabled$().pipe(ignoreNil())),
			filter(([, enabled]) => enabled),
			switchMap(() =>
				this.service.hasReachedThreshold().pipe(
					map((hasReachedThreshold) => DepositThresholdAction.fetchSuccess(hasReachedThreshold)),
					catchError((error) => of(DepositThresholdAction.fetchFailure(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private kycConfig: KycConfig,
		private service: DepositThresholdService
	) {}
}
